import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';

import mixpanel from "mixpanel-browser";
import axios from "axios";
import { Button } from "react-bootstrap";
import { Grid, Row, Col } from "react-bootstrap";

import '../content/content.css';


class ApiKeyDashboard extends Component {

	constructor() {
		super();
		this.getApiKeys = this.getApiKeys.bind(this);
		this.state = { apiKeys : [], apiCallCount: 0 };
		this.mixpanel = mixpanel;
		this.generateApiKey = this.generateApiKey.bind(this);
		this.deleteKey = this.deleteKey.bind(this);
	}

	componentDidMount() {
		this.getApiKeys();
	}

	getApiKeys() {
        let that = this;
        axios
            .get("/api/users/api-keys", {
                params: { }
            })
            .then(function(response) {            	
                that.setState({ loading: false });
                that.setState({ apiKeys: response.data });

                that.mixpanel.track("Get API Keys", {
                    success: true,                    
                    isLoggedIn: that.state.isLoggedIn
                });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Search failed", {
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });                
                that.setState({error: true, loading: false, apiKeys: {}});
            });
    }


    getApiCallCount() {
        let that = this;
        axios
            .get("/api/api-calls", {
                params: { }
            })
            .then(function(response) {              
                that.setState({ loading: false });
                that.setState({ apiCallCount: response.data.count });

                that.mixpanel.track("Get Api Call Count", {
                    success: true,                    
                    isLoggedIn: that.state.isLoggedIn
                });
            })
            .catch(function(error) {                
                that.mixpanel.track("Api Call Count failed", {
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });                
                that.setState({error: true, loading: false, apiCallCount: {}});
            });
    }

    createApiKey(callback) {
    	let that = this;
        axios
            .post("/api/users/api-keys", {
                params: { }
            })
            .then(function(response) {
                that.setState({ loading: false });
                callback();
                that.mixpanel.track("Create API Key", {
                    success: true,                    
                    isLoggedIn: that.state.isLoggedIn
                });
            })
            .catch(function(error) {
            	callback();
                that.mixpanel.track("Create API Key failed", {
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });                
                that.setState({error: true, loading: false });
            });
    }

    deleteKey(keyId, callback) {
    	let that = this;
        axios
	        .delete("/api/users/api-keys/" + keyId, {
	            params: { }
	        })
	        .then(function(response) {
	            that.setState({ loading: false });
	            callback();
	            that.mixpanel.track("Delete API Key", {
	                success: true
	            });
	        })
	        .catch(function(error) {
	        	callback();
	            that.mixpanel.track("Delete API Key failed", {
	                success: false,
	                error: error
	            });                
	            that.setState({error: true, loading: false });
	        });
    }

    renderApiKeys() {
    	let keys = []

    	if (this.state.apiKeys && this.state.apiKeys.length > 0) {
    			keys = this.state.apiKeys.map(
    				(apiKey) => 
    				apiKey.status === 'ACTIVE' ?
    					<Row key={apiKey.value}>
    						<Col md={12} className="text-center">
                                <div className="apiKeyContainer">
    							     <span className="apiKey">{apiKey.value}</span>
    							     <Button bsSize="sm" onClick={this.deleteKey.bind(null, apiKey.id, this.getApiKeys)}>Delete</Button>
                                </div>
			    			</Col>
		    			</Row>
	    			: ""
    		)
		}

    	return (
    		<div>
    			{keys}
    		</div>
    	)
    }

    renderApiCallCount() {

    }

    generateApiKey() {
    	this.createApiKey(this.getApiKeys);
    }

	render() {
		return (
			<Grid>
				{this.renderApiKeys()}
                <br />
				<Row>
					<Col md={12} className="text-center">
						<Button onClick={this.generateApiKey}>Generate a new API key</Button>						
					</Col>
				</Row>
			</Grid>
		)
	}
}

export default ApiKeyDashboard;



// WEBPACK FOOTER //
// ./src/api/ApiKeyDashboard.js